"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const padding = 10;
const radius = 4;
const SvgBox = (props) => {
    const { size, strokeColor, fillColor } = props;
    return (react_1.default.createElement("svg", { width: size, height: size },
        react_1.default.createElement("path", { d: `M${radius + 1},1 
            h${size - padding}
            a${radius},${radius} 0 0 1 ${radius},${radius} 
            v${size - padding} 
            a${radius},${radius} 0 0 1 -${radius},${radius} 
            h-${size - padding} 
            a${radius},${radius} 0 0 1 -${radius},-${radius} 
            v-${size - padding} 
            a${radius},${radius} 0 0 1 ${radius},-${radius} 
            z`, fill: fillColor, stroke: strokeColor })));
};
SvgBox.propTypes = {
    size: prop_types_1.default.number.isRequired,
    strokeColor: prop_types_1.default.string.isRequired,
    fillColor: prop_types_1.default.string.isRequired,
};
exports.default = SvgBox;
